<div>
  <h2 class="step-title is-size-4-mobile">{{ title }}</h2>
  @if (subtitle) {
    <h3 class="step-subtitle">{{ subtitle }}</h3>
  }

  <div class="field">
    <div [ngClass]="{'control': true}">
      <input
        class="input is-large"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
        type="tel" inputmode="tel" placeholder="(XXX) XXX-XXXX" formControlName="phoneNumber" name="tel" autocomplete="tel" [imask]="phoneMask" #phone (change)="phoneChange($event)" (input)="phoneInput($event)">
    </div>

    @if (controls[0].touched && controls[0].errors) {
      <div class="help is-danger has-text-left">
        @if (controls[0].errors.required) {
          <p>Phone Number is required.</p>
        }
        @if (controls[0].errors.pattern) {
          <p>Invalid Phone Number.</p>
        }
      </div>
    }
  </div>

  @if (isShowLenders) {
    <div class="field lender-checkboxes">
      @if (selectedType.getValue() == 'top10') {
        <h4 class="get_lendes_title">
          Get Rates from {{branded.bank_name}} & checked lenders
          <span style="display: block;">(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span>
          <span style="font-size: 0.8em;display: block;">All Lenders are checked by default & displayed in a random order</span>
        </h4>
      }
      @if (selectedType.getValue() != 'top10') {
        <h4 class="get_lendes_title">
          Get Rates from Checked Lenders <span>(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span>
          <span style="font-size: 0.8em;display: block;">All Lenders are checked by default & displayed in a random order</span>
        </h4>
      }
      @if (showLenderError) {
        <div class="is-danger help">
          At least one lender must be selected
        </div>
      }
      <div class="columns">
        <div class="column">
          <div #lenderList class="lender-list">
            @for (lender of finalLenders; track lender; let i = $index) {
              <div class="control has-text-centered">
                <label [class]="['checkbox', lender?.featured && lender?.logo != ''? 'featured' : '']">
                  <input type="checkbox"  formArrayName="lenders" (change)="onCheckChange($event)" [value]="lender.id" id = "leadid_tcpa_brandname_0{{i+1}}" [checked]="lender.checked && jornaya">
                  <label [class]="lender?.logo != '' && lender?.featured ? 'is-hidden' : ''" for = "leadid_tcpa_brandname_0{{i+1}}"> {{ lender?.bank_name }}</label>
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (!isPreferBox) {
    <div class="field checkboxes">
      <div class="control has-text-centered">
        <label class="checkbox">
          <input type="checkbox" formControlName="sms" (change)="snap()">
          Prefers text
        </label>
      </div>
      <div class="control has-text-centered">
        <label class="checkbox">
          <input type="checkbox" formControlName="email_preference" (change)="snap()">
          Prefers email
        </label>
      </div>
      <!-- Functional Prefers Spanish Button -->
      <div class="control has-text-centered">
        <label class="checkbox">
          <input type="checkbox" formControlName="prefers_spanish" (change)="prefersSpanishSelected()">
          Prefers Spanish <span>(Espa<span>&#241;</span>ol)</span>
        </label>
      </div>
      <!-- FRU-21436: new 100% digital contact preference -->
      <div class="control has-text-centered">
        <label class="checkbox">
          <input type="checkbox" formControlName="prefers_digital" (change)="snap()">
          Prefers 100% digital
        </label>
      </div>
    </div>
  }

  <button class="button continue is-large has-shadow-small" (click)="phoneSubmit(isUncheckedValidation)">
    {{ submitButtonText }}@if (isSelectedRun) {
    <span style="font-size: 15px; vertical-align: text-top;">*</span>
  }
  <i class="fas fa-chevron-right"></i>
</button>

@if (isPreferBox) {
  <div class="field checkboxes-new">
    <label class="checkbox">
      <input type="checkbox" formControlName="sms" (change)="snap()">
      Prefers text
    </label>
    <label class="checkbox">
      <input type="checkbox" formControlName="email_preference" (change)="snap()">
      Prefers email
    </label>
    <label class="checkbox">
      <input type="checkbox" formControlName="prefers_spanish" (change)="prefersSpanishSelected()">
      Espa<span>&#241;</span>ol
    </label>

    <label class="checkbox">
      <input type="checkbox" formControlName="prefers_digital" (change)="snap()">
      Prefers 100% digital
    </label>
  </div>
}

<!-- WARNING: The content of this disclosure is extremely important. Neither the text, nor the font size,
nor the color may be changed, without confirmation with Ed and Anthony and approval from our lenders.-->

@if (!isSelectedRun) {
  <p class="tcpa is-size-7 has-text-grey-dark has-text-left gray-tcpa-disclosure">
    <input type="hidden" id="leadid_tcpa_disclosure_form">
    <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
      @if (form.value.propertyState !== 'NY') {
        <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC and its <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer" (click)="trackAndNavigate($event, 127)">network of lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
      }
      @if (form.value.propertyState === 'NY') {
        <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC, including its network members LoanDepot, Rocket Mortgage, <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer" (click)="trackAndNavigate($event, 127)"> and other lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
      }
      <br/><br/>
      I also agree to and am electronically signing FreeRateUpdate.com's @if (!fruLocalKiosk) {
      <a href="/privacy" target="_blank" rel="nofollow noopener noreferrer" (click)="trackAndNavigate($event, 128)">Privacy Policy</a>
      } and its @if (!fruLocalKiosk) {
      <a href="/terms" rel="nofollow noopener noreferrer" target="_blank"  (click)="trackAndNavigate($event, 129)">Terms and Conditions</a>
      }.
    </label>
  </p>
}

@if (isSelectedRun) {
  <p class="tcpa is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;">
    <input type="hidden" id="leadid_tcpa_disclosure_form">
    <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
      *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
    </label>
  </p>
}

@if (canEditScores) {
  <div class="field edit-scores">
    Manual Override
    <label>Phone Score:
      <input type="number" class="input" formControlName="phonescore_override" step="5" min="0" max="100" />
    </label>
    <label>Email Score:
      <input type="number" class="input" formControlName="emailscore_override" step="5" min="0" max="100" />
    </label>
    <div style="clear:both"></div>
  </div>
}
</div>
